<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_1"></a><strong>I WISH</strong></h1>
<p class="author">by Nancy Guettier</p>
<p class="imaget"><img alt="image" src="images/f0001-01.jpg"/></p>
<p class="author1">Illustrated by Meegan Barnes</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2e99afda